var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkingHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.158 496.158",
    style: {
      enableBackground: "new 0 0 496.158 496.158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07 c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.014,
    y1: 139.1276,
    x2: 295.144,
    y2: 139.1276,
    gradientTransform: "matrix(1 0 0 -1 0 498.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47474A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#616268"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E75"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M282.87,366.303l0.202-33.55c0-2.904-2.355-5.261-5.259-5.261h-59.468 c-2.912,0-5.259,2.357-5.259,5.261l0.225,33.446l-12.297,18.483v3.586c0,2.904,2.354,2.234,5.257,2.234h83.605 c2.905,0,5.268,0.67,5.268-2.234v-3.586L282.87,366.303z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.079,
    y1: 173.675,
    x2: 248.079,
    y2: 111.1617,
    gradientTransform: "matrix(1 0 0 -1 0 498.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    style: {
      stopColor: "#737377"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    style: {
      stopColor: "#707073"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#656766"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    style: {
      stopColor: "#4D4D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#343439"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M282.87,363.289l0.202-33.547c0-2.914-2.355-5.259-5.259-5.259h-59.468 c-2.912,0-5.259,2.345-5.259,5.259l0.225,33.444l-12.297,21.498c0,2.908,2.354,2.248,5.257,2.248h83.605 c2.905,0,5.268,0.66,5.268-2.248L282.87,363.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#08090B"
    },
    d: "M393.959,105.588h-291.76c-10.925,0-19.776,8.859-19.776,19.782V320.7 c0,10.923,8.852,19.774,19.776,19.774h291.76c10.918,0,19.776-8.852,19.776-19.774V125.37 C413.735,114.447,404.877,105.588,393.959,105.588z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.649,
    y: 118.589,
    style: {
      fill: "#343433"
    },
    width: 302.26,
    height: 1.038
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#08090B"
    },
    d: "M102.199,105.588c-10.925,0-19.776,8.859-19.776,19.782v171.559h14.225V118.885h237.694 l9.296-13.296L102.199,105.588L102.199,105.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#08090B"
    },
    d: "M393.959,105.588h-50.321l-9.296,13.296h64.566v178.045h14.827V125.371 C413.735,114.447,404.877,105.588,393.959,105.588z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.342,
    y1: 296.8995,
    x2: 427.072,
    y2: 296.8995,
    gradientTransform: "matrix(1 0 0 -1 0 498.158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#959397"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    style: {
      stopColor: "#A6A4AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#C4C2CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0CED9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M393.959,105.588h-50.321l-9.296,13.296h64.566v178.045h14.827V125.371 C413.735,114.447,404.877,105.588,393.959,105.588z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96.649,
    y: 118.889,
    style: {
      fill: "#3a7fed"
    },
    width: 302.26,
    height: 207.35
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#337180"
    },
    d: "M248.08,133.502c-48.646,0-88.08,39.431-88.08,88.081c0,48.642,39.434,88.077,88.08,88.077 c48.643,0,88.078-39.435,88.078-88.077C336.158,172.933,296.723,133.502,248.08,133.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D5E0"
    },
    d: "M308.99,225.715c8.296-2.825,17.335-4.719,27.149-5.616c-0.027-1.586-0.093-3.161-0.201-4.725 c-10.466,0.939-19.739,2.944-27.958,5.731c-2.221-9.485-5.096-17.952-8.396-25.497c8.719-3.636,17.795-8.115,27.205-13.588 c-0.711-1.41-1.453-2.799-2.236-4.165c-9.331,5.433-18.32,9.86-26.941,13.447c-6.474-13.48-14.25-23.798-21.772-31.548 c-2.271-2.34-4.561-4.497-6.847-6.494c8.567-2.373,17.7-4.153,27.399-5.331c-2.106-1.384-4.272-2.684-6.497-3.886 c-7.639,1.156-14.767,2.684-21.425,4.525c1.589-4.548,3.188-8.444,4.536-11.483c-1.543-0.455-3.104-0.871-4.681-1.242 c-1.518,3.408-3.282,7.739-4.993,12.779c-9.481-7.276-18.489-11.822-25.181-14.56c-3.261,0.366-6.467,0.906-9.608,1.618 c5.166,1.542,17.357,5.9,30.642,15.755c-17.911,6.146-32.002,14.685-43.1,24.233c-6.875-13.55-14.294-22.941-17.638-26.857 c-1.309,0.895-2.59,1.823-3.845,2.785c3.089,3.613,10.838,13.321,17.821,27.344c-6.732,6.302-12.253,12.959-16.776,19.604 c-12.354-4.033-21.755-9.291-27.824-13.305c-0.665,1.468-1.29,2.959-1.876,4.469c6.139,3.997,15.211,8.973,27.029,12.943 c-2.753,4.426-5.099,8.813-7.068,13.05c-2.503,5.377-4.525,10.686-6.17,15.806c-9.424-15.077-14.303-28.702-16.19-34.731 c-0.825,2.81-1.513,5.679-2.056,8.598c3.015,8.023,8.213,19.694,16.469,32.114c-3.333,12.185-4.544,22.884-4.953,30.176 c1.417,2.303,2.935,4.539,4.551,6.694c0.012-5.331,0.498-17.251,3.988-31.713c1.504,2.073,3.083,4.156,4.764,6.236 c7.544,9.334,17.53,19.224,30.401,27.639c-3.148,7.351-7.108,14.62-11.88,21.8c1.375,0.777,2.771,1.516,4.193,2.219 c4.797-7.293,8.632-14.487,11.66-21.534c7.451,4.481,15.799,8.447,25.127,11.551c-2.065,7.935-2.961,14.638-3.352,18.918 c1.574,0.099,3.157,0.156,4.751,0.172c0.39-4.042,1.249-10.299,3.142-17.664c12.006,3.511,25.543,5.603,40.768,5.603 c0.498,0,1.002-0.009,1.502-0.013c2.6-1.528,5.115-3.184,7.535-4.962c-17.51,0.955-33.721-0.733-48.578-5.029 c1.658-5.561,3.901-11.576,6.945-17.637c4.803-9.563,10.77-17.769,17.856-24.632c8.145,9.222,18.722,17.098,31.66,23.589 c-0.081,5.859-0.377,11.863-0.89,18.007c1.769-1.602,3.475-3.277,5.109-5.017c0.235-3.662,0.395-7.241,0.474-10.73 c2.028,0.925,4.112,1.815,6.243,2.679c0.958-1.298,1.883-2.626,2.77-3.978c-3.094-1.233-6.064-2.536-8.936-3.898 C312.838,250.922,311.417,237.573,308.99,225.715z M265.861,156.806c2.204,1.92,4.408,3.991,6.59,6.238 c8.405,8.659,15.342,18.709,20.797,30.014c-11.165,4.339-21.681,7.251-31.487,9.071 C259.535,185.743,262.203,169.642,265.861,156.806z M261.137,155.655c-3.793,13.313-6.504,30.044-4.073,47.275 c-11.05,1.704-21.142,2.032-30.172,1.489c-0.882-3.565-1.882-6.95-2.955-10.125c-1.747-5.171-3.729-9.992-5.807-14.434 C230.05,169.337,244.403,161.257,261.137,155.655z M214.475,183.241c1.786,3.914,3.481,8.111,4.988,12.565 c0.928,2.748,1.742,5.488,2.467,8.224c-6.29-0.62-12.016-1.643-17.121-2.878c-1.541-0.373-3.039-0.773-4.509-1.189 C204.506,193.874,209.239,188.305,214.475,183.241z M218.454,272.215c-10.407-6.971-19.874-15.693-28.356-26.163 c-2.529-3.121-4.85-6.262-6.975-9.372c1.77-6.145,4.093-12.62,7.146-19.156c2.199-4.708,4.646-9.176,7.319-13.424 c1.886,0.555,3.829,1.083,5.839,1.576c5.813,1.421,12.402,2.572,19.688,3.199C227.906,230.466,226.341,251.645,218.454,272.215z  M254.223,267.988c-3.145,6.289-5.462,12.477-7.182,18.193c-8.691-2.881-16.902-6.686-24.618-11.418 c9.537-24.611,9.306-47.229,5.544-65.562c2.283,0.114,4.607,0.191,7.016,0.191c7.099,0,14.733-0.536,22.861-1.792 c0.83,4.235,1.985,8.485,3.539,12.704c2.862,7.775,6.883,14.939,12.039,21.479C264.628,250.184,258.48,259.472,254.223,267.988z  M276.946,238.585c-4.752-6.079-8.475-12.707-11.121-19.884c-1.452-3.938-2.534-7.916-3.308-11.896 c10.189-1.886,21.115-4.917,32.705-9.44c3.456,7.897,6.221,16.372,8.286,25.384C292.861,226.921,284.113,232.435,276.946,238.585z  M279.877,242.107c7.167-6.187,15.387-11.105,24.619-14.761c2.252,11.302,3.442,23.408,3.559,36.249 C296.602,257.579,287.191,250.407,279.877,242.107z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 306.129,
    cy: 224.179,
    r: 6.888
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 276.409,
    cy: 241.489,
    r: 6.888
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 248.459,
    cy: 289.509,
    r: 6.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAEBF4"
    },
    d: "M219.535,268.454c-3.801,0-6.888,3.083-6.888,6.888s3.087,6.887,6.888,6.887 c3.804,0,6.89-3.082,6.89-6.887S223.339,268.454,219.535,268.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 180.379,
    cy: 236.969,
    r: 6.888
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 196.709,
    cy: 201.149,
    r: 6.888
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 225.439,
    cy: 206.859,
    r: 6.887
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 215.009,
    cy: 178.919,
    r: 6.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAEBF4"
    },
    d: "M264.798,142.901c-4.781,0-8.66,3.874-8.66,8.659c0,4.784,3.879,8.658,8.66,8.658 c4.782,0,8.658-3.874,8.658-8.658C273.456,146.775,269.58,142.901,264.798,142.901z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 259.679,
    cy: 205.289,
    r: 6.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAEBF4"
    },
    d: "M296.875,187.376c-3.806,0-6.886,3.082-6.886,6.887c0,3.806,3.08,6.889,6.886,6.889 c3.805,0,6.888-3.083,6.888-6.889C303.763,190.458,300.68,187.376,296.875,187.376z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BAEBF4"
    },
    cx: 310.259,
    cy: 266.679,
    r: 6.888
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingHover);
export default __webpack_public_path__ + "static/media/NetworkingHover.5eb55fa4f479f221f99d409eb1b9b792.svg";
export { ForwardRef as ReactComponent };